import Handlebars from "handlebars";

Handlebars.registerHelper("backgroundColor", function (color, options) {
  if (!color) {
    return "transparent";
  }

  if (color[0] != "#") {
    return "#" + color;
  }

  return color;
});
